import React, { useEffect } from "react";
import { Button, Form, Input, Space, Select, Switch } from "antd";
import { Sdk, SdkCategory, SdkStability } from "../../../types/sdk";
import { Platform } from "../../../types/platform";
import { Requirement } from "../../../types/requirement";

const { Option } = Select;

export interface SdkFormProps {
  sdk?: Sdk;
  isLoading?: boolean;
  onFinish: (sdk: Sdk) => void;
}

export const SdkForm = (props: SdkFormProps) => {
  const [form] = Form.useForm();

  const onReset = () => {
    form.resetFields();
  };

  const onFinish = (values: any) => {
    const sdk: Sdk = { ...props.sdk, ...values };
    form.resetFields();
    props.onFinish(sdk);
  };

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue(props.sdk);
  }, [props.sdk, form]);

  return (
    <Form
      form={form}
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 16 }}
      layout="horizontal"
      onFinish={onFinish}
    >
      <Form.Item
        label="Status"
        name="status"
        rules={[{ required: true, message: "Please input status" }]}
      >
        <Input />
      </Form.Item>
      <Form.Item name="platform" label="Platform">
        <Select style={{ width: 120 }}>
          <Option value={Platform.ANDROID}>Android</Option>
          <Option value={Platform.IOS}>IOS</Option>
        </Select>
      </Form.Item>
      <Form.Item
        label="Display Name"
        name="name"
        rules={[{ required: true, message: "Please input name" }]}
      >
        <Input />
      </Form.Item>
      <Form.Item name="version" label="Version">
        <Input />
      </Form.Item>
      <Form.Item name="category" label="Category">
        <Select style={{ width: 150 }}>
          <Option value={SdkCategory.AD_NETWORK}>Ad Network</Option>
          <Option value={SdkCategory.MEDIATION}>Mediation</Option>
          <Option value={SdkCategory.SERVICE}>Service</Option>
          <Option value={SdkCategory.OTHER}>Other</Option>
        </Select>
      </Form.Item>
      <Form.Item name="stability" label="Stability">
        <Select style={{ width: 150 }}>
          <Option value={SdkStability.STABLE}>Stable</Option>
          <Option value={SdkStability.BETA}>Beta</Option>
          <Option value={SdkStability.ALPHA}>Alpha</Option>
          <Option value={SdkStability.CUSTOM}>Custom</Option>
        </Select>
      </Form.Item>
      <Form.Item name="requirement" label="Requirement">
        <Select style={{ width: 150 }}>
          <Option value={Requirement.DEFAULT}>Default</Option>
          <Option value={Requirement.OPTIONAL}>Optional</Option>
          <Option value={Requirement.REQUIRED}>Required</Option>
          <Option value={Requirement.DEPRECATED}>Deprecated</Option>
        </Select>
      </Form.Item>
      <Form.Item name="message" label="Message">
        <Input placeholder="Tooltip message for version" />
      </Form.Item>
      <Form.Item
        name="reindexEnabled"
        label="Reindex"
        valuePropName="checked"
        tooltip="Force the crawler to reindex this version every cron run (use for pinned versions outside top-3 latest)"
      >
        <Switch />
      </Form.Item>
      <Form.Item wrapperCol={{ offset: 6, span: 16 }}>
        <Space>
          <Button loading={props.isLoading} type="primary" htmlType="submit">
            {props.sdk ? "Update" : "Create"}
          </Button>
          <Button htmlType="button" onClick={onReset}>
            Reset
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};
